import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services/auth.service';

export const GET_DISTRICTS = 'GET_DISTRICTS';
export const ADD_DISTRICT = 'ADD_DISTRICT';
export const GET_COUNTIES = 'GET_COUNTIES';
export const GET_COUNTIES_ON_EDIT = 'GET_COUNTIES_ON_EDIT';
export const DELETE_DISTRICT = 'DELETE_DISTRICT';
export const UPDATE_DISTRICT = 'UPDATE_DISTRICT';

const successColor = 'success';
const errorColor = 'danger';
const warningColor = 'warning';

export function fetchDistricts() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageDistrict/GetDistricts`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_DISTRICTS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function getCounties(stateId) {
    return function (dispatch) {
		axios.get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${stateId}`, { headers: auth.authHeader() })
			.then((response) =>{
				dispatch({
					type: GET_COUNTIES,
					payload: response.data
				})})
			.catch((response) => {
				console.log(response);
			});
	};
}

export function getAvailableCounties(stateId) {
    return function (dispatch) {
		axios.get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${stateId}`, { headers: auth.authHeader() })
			.then((response) =>{
				dispatch({
					type: GET_COUNTIES,
					payload: response.data
				})})
			.catch((response) => {
				console.log(response);
			});
	};
}


export function setCounties(counties) {
    return function (dispatch) {		
		dispatch({
			type: GET_COUNTIES,
			payload: counties
		})
	};
}

export function getCountiesOnEdit(model) {
    return function (dispatch) {
        axios
			.get(`${ROOT_API_URL}/ManageDistrict/GetCountiesOnEdit`, model, { headers: auth.authHeader() })
            .then((response) =>
                dispatch({
                    type: GET_COUNTIES_ON_EDIT,
                    payload: response.data
                })
            )
            .catch((response) => {
                console.log(response);
            });
    };
}

export function addDistrict(model) {
	console.log('too see what action creator received: ', model, { headers: auth.authHeader() });
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageDistrict/CreateDistrict`, model, { headers: auth.authHeader() })
            .then(function (response) {
				console.log('to see the response from back end: ', response);
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: ADD_DISTRICT,
						payload: response.data.districts
					});
					var success = response && response.data ? response.data.message : 'District Created Successfully';
					dispatch(toastr(true, success, successColor));
				} else {
					var err = response && response.data ? response.data.message : 'District Already Exists';
					dispatch(toastr(true, err, warningColor));
				}
				dispatch(loader(false));
			})
            .catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function deleteDistrict(model) {
	return function(dispatch) {
		axios
			.post(`${ROOT_API_URL}/ManageDistrict/DeleteDistrict`, model, { headers: auth.authHeader() })
			.then((response) =>
				dispatch({
					type: DELETE_DISTRICT,
					payload: response.data
				})
			)
			.catch((response) => {
				console.log(response);
			});
	};
}

export function updateDistrict(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageDistrict/UpdateDistrict`, model, { headers: auth.authHeader() })
			.then((response) => {
				console.log('update response', response);
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: UPDATE_DISTRICT,
						payload: response.data.districts
					});
					var success = response && response.data ? response.data.message : 'District Updated Successfully';
					dispatch(toastr(true, success, successColor));
				} else {
					var err = response && response.data ? response.data.message : 'Error Occured';
					dispatch(toastr(true, err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(toastr(true, err, errorColor));
			});
	};
}
